module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAARVBMVEUAAAA8PDw8PDw8PDw6Ojo2NjY8PDw8PDw8PDw9PT09PT08PDw9PT05OTkiIiI9PT08PDw8PDw9PT09PT08PDw9PT09PT260A7WAAAAFnRSTlMAx+mtMhX0fM60l00/Lgfi4bq5o6J9kLilrgAAAGtJREFUKM/FzjsOhDAQBFGPbWxgF/ZL3f+ojJAIgCZDopIJnjTqcG0GVAV4SUEBooIX3lPAB68XMAGpETCAne7NEh7QjlI6+EtoIvxGv/1+dS7Q5pAgprqVCBhLu28da4dtpsEb6vddsHB7M+m9BrxOoNKYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus/content_tel.png
// module id = HoW2
// module chunks = 44